<template>
  <div>
    <PCNavbar class="hidden-xs-only none_992" />
    <MobileNavBar class="hidden-md-and-up" />
    <TitleComponent class="hidden-xs-only none_992" />
    <TitleComponentMobile class="hidden-md-and-up" />
    <template
      v-if="currentSource.startsWith('product_lie_') && parseInt(currentSource.split('_')[2]) >= 1 && parseInt(currentSource.split('_')[2]) <= 18 && currentSource !== 'product_lie_11' && currentSource !== 'product_lie_12'">
      <ModelComponent class="hidden-xs-only none_992" />
      <ModelComponentMobile class="hidden-md-and-up" />
      <FunctionFeatures class="hidden-xs-only none_992" />
      <FunctionFeaturesMobile class="hidden-md-and-up" />
      <ApplicationField class="hidden-xs-only none_992" />
      <ApplicationFieldMobile class="hidden-md-and-up" />
    </template>
    <template v-else>
      <ProductFeatures class="hidden-xs-only none_992" />
      <ProductFeaturesMobile class="hidden-md-and-up" />
      <FunctionFeatures class="hidden-xs-only none_992"
        v-if="currentSource === 'product_lie_11' || currentSource === 'product_lie_12'" />
      <FunctionFeaturesMobile class="hidden-md-and-up"
        v-if="currentSource === 'product_lie_11' || currentSource === 'product_lie_12'" />
      <SmartDevices class="hidden-xs-only none_992" />
      <SmartDevicesMobile class="hidden-md-and-up" />
      <UserCases class="hidden-xs-only none_992" />
      <UserCasesMobile class="hidden-md-and-up" />
    </template>
    <CallMe class="hidden-xs-only none_992" />
    <MobileCallme class="hidden-md-and-up" />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import TitleComponent from '@/components/titleComponent/index'
import TitleComponentMobile from '@/components/titleComponentMobile/index'
import ModelComponent from '@/components/modelComponent/index'
import ModelComponentMobile from '@/components/MobileModelComponent/index'
import ProductFeatures from '@/components/productFeatures/index'
import ProductFeaturesMobile from '@/components/productFeaturesMobile/index'
import FunctionFeatures from '@/components/functionFeatures/index'
import FunctionFeaturesMobile from '@/components/FunctionFeaturesMobile/index'
import ApplicationField from '@/components/applicationField/index'
import ApplicationFieldMobile from '@/components/applicationFieldMobile/index'
import SmartDevices from '@/components/smartDevices/index'
import SmartDevicesMobile from '@/components/smartDevicesMobile/index'
import UserCases from '@/components/user_cases/index'
import UserCasesMobile from '@/components/user_cases_mobile/index'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/callMeMile.vue'
export default {
  components: {
    PCNavbar,
    TitleComponent,
    TitleComponentMobile,
    ModelComponent,
    ModelComponentMobile,
    ProductFeatures,
    ProductFeaturesMobile,
    FunctionFeatures,
    FunctionFeaturesMobile,
    ApplicationField,
    ApplicationFieldMobile,
    SmartDevices,
    SmartDevicesMobile,
    UserCases,
    UserCasesMobile,
    CallMe,
    MobileCallme,
    MobileNavBar
  },
  data() {
    return {
      selectedText: '', // 初始化 selectedText
      currentSource: '', // 用于存储当前的 source 参数
    };
  },
  created() {
    // 模拟从 localstory 获取数据
    this.selectedText = localStorage.getItem('selectedText') || '';
    this.currentSource = new URLSearchParams(window.location.search).get('source') || '';

  },
  watch: {
    // 监听路由变化
    '$route'(to, from) {
      const newSource = to.query.source || ''; // 获取新的 source 参数
      this.currentSource = newSource;
      // 这里可以执行相应的操作
    }

  },
  mounted() {
    window.addEventListener('storage', this.handleStorageChange);
    // 初始化时手动触发一次更新
    this.selectedText = localStorage.getItem('selectedText') || '';
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleStorageChange);
  },
  methods: {
    handleStorageChange(event) {

      if (event.key === 'selectedText') {
        const newValue = localStorage.getItem('selectedText') || '';
        if (newValue !== this.selectedText) {
          this.selectedText = newValue; // 更新 selectedText，触发监听
        }
      }
    },
    safeNavigateTo(route) {
      if (this.$route.fullPath !== route) {
        this.$router.push(route).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err);
          }
        });
      }
    },
  },
}
</script>

<style>
@media (max-width: 992) {
  .none_992 {
    display: none !important;
  }
}
</style>